(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("BMap"));
	else if(typeof define === 'function' && define.amd)
		define(["BMap"], factory);
	else if(typeof exports === 'object')
		exports["ucp-cli3-app"] = factory(require("BMap"));
	else
		root["ucp-cli3-app"] = factory(root["BMap"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__71f3__) {
return 